/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const WifiBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><g><path d="M21.235 9.512a.487.487 0 0 0-.006-.684 13.467 13.467 0 0 0-4.054-2.744A12.95 12.95 0 0 0 12 5c-1.776 0-3.535.368-5.176 1.083A13.467 13.467 0 0 0 2.77 8.828a.487.487 0 0 0-.005.684l1.774 1.865a10.62 10.62 0 0 1 7.46-3.056 10.62 10.62 0 0 1 7.462 3.056l1.774-1.865Z" /><path d="M18.427 12.465a9.135 9.135 0 0 0-12.854 0L8 15.017a5.701 5.701 0 0 1 4-1.633c1.56 0 2.967.624 4 1.633l2.427-2.552Z" /><path d="m12.362 18.843 2.604-2.738a4.217 4.217 0 0 0-5.933 0l2.604 2.738a.5.5 0 0 0 .725 0Z" /></g></svg>);
const Wifi = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={WifiBase} {...rest} ref={ref} />);
export default Wifi;